export default class rmFileRead {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                rmFileRead: "="
            },
            controller:
                ['$scope', '$element', (scope, element) => {
                element.bind('change', (changeEvent) => {
                    scope.$apply(() => {
                        scope.rmFileRead = changeEvent.target.files[0];
                    });
                })
            }]
        }
    }
};
